module.exports = urlUtils = {
  parseLocationHash: () ->
    this.parseQueryString(location.hash.replace(/^#/,''))

  currentFragment: () ->
    frag = location.hash.replace(/^#/,'')
    if frag.length
      frag = '#' + frag
    return frag

  parseQueryString: (qs) ->
    if Finch?.Utility?.parseQueryString
      return Finch.Utility.parseQueryString(qs)
    else
      params = {}
      qs = qs.replace(/^\?/,'')
      $.each qs.split('&'), (c,q)->
        i = q.split('=')
        if i[0]
          params[i[0]] = unescape(i[1])
      return params

  buildQueryString: (queryMap) ->
    urlQuery = []
    urlPath = ''
    for key of queryMap
      urlQuery.push(encodeURIComponent(key) + "=" + encodeURIComponent(queryMap[key]))
    if urlQuery.length
      urlPath = '?' + urlQuery.join('&')
    return urlPath

  setFragment: (frag) -> # by default we are passive, replacing state instead of adding new entries, this is because we do not respond to back button when the hash alone changes
    if history.replaceState and history.state
      qs = window.location.search.replace(/^\?/,'')
      qs = '?' + qs if qs.length
      frag = '#' + frag if frag.length
      history.replaceState(history.state,document.title,window.location.pathname + qs + frag)
    else
      location.hash = frag

  apiQueryBuilder: (opts) ->
    query_filter_string = ""
    if opts.filterQuery
      query_filter_string = "filterQuery=#{opts.filterQuery}"
    else if opts.isCategoryFallback
      query_filter_string = "categoryFallback=#{opts.categoryFallback}"
    else
      query_filter_string = "dealType=#{opts.dealType}"
    query_filter_string += "&context=#{opts.context}" if opts.context
    query_filter_string += "&divisionOverride=#{opts.division}" if opts.division
    query_filter_string += "&showOptions=#{opts.showOptions}" if opts.showOptions
    query_filter_string += "&divisionLoc=#{opts.latLng}" if opts.latLng and opts.filterQuery
    query_filter_string += "&pageType=#{opts.pageType}" if opts.pageType
    query_filter_string += "&unsafe=#{opts.unsafe}" if opts.unsafe
    query_filter_string += "&omitHero=true" if opts.noHero
    query_filter_string += "&includeHtml=true" if opts.includeHtml

    if opts.includeQuery and window.location.search
      query_filter_string += window.location.search.replace(/^\?/,'&')
    query_filter_string
}
